import { fetchHTML } from './utils-fetch-html.js';

class CollectionGrid extends HTMLElement {
  abortController;

  connectedCallback() {
    this.unsubscribeSortChanged = subscribe(
      'sort:changed',
      this.handleCollectionRerender.bind(this)
    );
    this.unsubscribeFiltersUpdated = subscribe(
      'filters:updated',
      this.handleCollectionRerender.bind(this)
    );
  }

  disconnectedCallback() {
    this.unsubscribeSortChanged();
    this.unsubscribeFiltersUpdated();
  }

  /**
   * Handle sort change
   */
  async handleCollectionRerender() {
    this.abortController?.abort();
    this.abortController = new AbortController();

    try {
      const searchParams = new URLSearchParams(window.location.search);
      const sectionId = this.getAttribute('data-section-id') || 'main-collection';
      const html = await fetchHTML(
        `${window.location.pathname}?section_id=${sectionId}&${searchParams}`
      );

      this.renderProductGrid(html);
    } catch (error) {
      console.error(error);
    }
  }

  /**
   * Render product grid
   * @param {HTMLElement} html - HTML to render
   */
  renderProductGrid(html) {
    const parsedCollectionGrid = html.querySelector('collection-grid');

    this.innerHTML = parsedCollectionGrid.innerHTML;
  }
}

customElements.define('collection-grid', CollectionGrid);
